import { IEmailPreference } from "../../types"

export const EMAIL_PREFERENCES: IEmailPreference[] = [
  {
    key: "new_lead",
    label: "New lead notifications",
    description:
      "Sends an email alert when a new lead is captured through your BankingBridge platform."
  },
  {
    key: "weekly_summary",
    label: "Weekly Stats Updates",
    description:
      "Provides a summary of your weekly performance metrics, including lead activity and engagement."
  },
  {
    key: "dashboard_usage",
    label: "Dashboard Visit Notifications",
    description:
      "Notifies you when a lead visits their personalized rate dashboard."
  },
  {
    key: "new_subscription",
    label: "New subscription added",
    description: "Triggered when a new user subscribes to receive rate alerts."
  },
  {
    key: "contact_form",
    label: "Contact form submitted",
    description:
      "Occurs when a user submits a message through the contact form."
  },
  {
    key: "chat_alert",
    label: "SMS alerts",
    description:
      "Sends an email in response to a chat-related event or message."
  }
]
